import { type FC, useMemo } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { Link } from '@vakantiesnl/components/src/atoms/Link';
import { Tag } from '@vakantiesnl/components/src/atoms/Tag';
import { ProductCardWrapper } from '@vakantiesnl/components/src/molecules/ProductCard/ProductCardWrapper';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import { type Search } from '@vakantiesnl/types';

type Props = {
	accommodation: Search.FullAccommodationItem;
	arrivalDate: string;
	bookingNumber: number;
	departureDate: string;
	isCancelled: boolean;
	position: number;
};

export const BookingAccommodationCard: FC<Props> = ({
	accommodation,
	arrivalDate,
	bookingNumber,
	departureDate,
	isCancelled,
	position,
}) => {
	const microCopies = useMicroCopyContext();

	const bookingLink = useMemo(
		() => `/${process.env.NEXT_PUBLIC_USER_BASE_PATH}/boeking/${bookingNumber}`,
		[bookingNumber],
	);
	const reviewUrl = useMemo(
		() => `/review?entityId=${accommodation.heliosId}&entityLevel=accommodation`,
		[accommodation.heliosId],
	);

	const TagContent = useMemo(
		() => (
			<Tag size="small" leadingIcon={isCancelled ? 'cancel' : 'calendar'} color={isCancelled ? 'red' : 'purple'}>
				{isCancelled
					? microCopies['user.booking.BookingAccoCard.text.cancelled']
					: `${departureDate} – ${arrivalDate}`}
			</Tag>
		),
		[arrivalDate, departureDate, isCancelled, microCopies],
	);

	return (
		<>
			<ProductCardWrapper
				accommodation={accommodation}
				size="tiny"
				tag={TagContent}
				customHref={bookingLink}
				position={position}
				hideRating
				openInSameTab
			/>
			{!isCancelled && process.env.NEXT_PUBLIC_BRAND === 'ZVRNL' && (
				<Link href={reviewUrl}>
					<Button variant="secondary" size="small" leadingIcon="editNav" asText>
						{microCopies['user.booking.BookingAccoCard.review.button']}
					</Button>
				</Link>
			)}
		</>
	);
};
